export { default as AdditionalCover } from './AdditionalCover';
export { default as MedicalDeclaration } from './MedicalDeclaration';
export { default as Payment } from './Payment';
export { default as QuoteSummary } from './QuoteSummary';
export { default as SchemeChoice } from './SchemeChoice';
export { default as TripDetails } from './TripDetails';
export { default as Complete } from './Complete';
